import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next"; // Import useTranslation
import cn from "classnames";
import style from "./common.module.scss";
import { File, MapsData, Order, User } from "../../../services";
import OrdersInfoCargo from "./components/OrdersInfoCargo";
import OrdersInfoHeader from "./components/OrdersInfoHeader";
import OrdersInfoBasic from "./components/OrdersInfoBasic";
import OrdersInfoDirections from "./components/OrdersInfoDirections";
import OrdersDriverInfo from "./components/OrdersDriverInfo";
import InfoIcon from "../../shared/icons/InfoIcon";
import Loading from "../../shared/Loading/Loading";
import { toast } from "react-toastify";
import ListSuggestedPrices from "./components/ListSuggestedPrices";
import { useSelector } from "react-redux";
import OrdersInfoAddressList from "./components/OrdersInfoAddressList";
import OrderBidOrBook from "./components/OrderBidOrBook";
import { useParams, useNavigate } from "react-router-dom";
import OrderHistoryMobile from "./components/mobile/OrderHistoryMobile";
import { useLocation } from "react-router-dom";
import OrderAccessRestricted from "./components/OrderAccessRestricted";
import { useLanguage } from "../../../context/LanguageContext";

const OrderInfoBookingCardMobile = ({
  isOpen,
  setIsOpen,
  companyName,
}) => {
  const { t } = useTranslation();
  const { currentLanguage } = useLanguage();
  const { user } = useSelector((state) => state);
  const company = useSelector((state) => state.user.company);
  const params = useParams();
  const location = useLocation();

  const isSearchPage = location.state?.isSearchPage ?? false;
  const orderId = params.id

  const [getOrder, setOrder] = useState(null);
  const [cargoDetails, setCargoDetails] = useState();
  const [recipient, setRecipient] = useState();
  const [bookingDate, setBookingDate] = useState();
  const [statusHistory, setStatusHistory] = useState();
  const [cityFrom, setCityFrom] = useState();
  const [cityTo, setCityTo] = useState();
  const [routeData, setRouteData] = useState(null);
  const [routeStartCity, setRouteStartCity] = useState(null);
  const [coordinate, setCoordinate] = useState([]);
  const [listDocDriver, setListDocDriver] = useState([]);
  const [driverPhotos, setDriverPhotos] = useState([]);
  const [listSuggestedPrice, setListSuggestedPrice] = useState([]);

  const [isLoading, setLoading] = useState(false);
  const [isLoadingMap, setIsLoadingMap] = useState(false);
  const [isOpenModalHistory, setIsOpenModalHistory] = useState(false);

  const onForceUpdate = () => {
    fetchOrderData();
  };

  const fetchOrderData = async () => {
    setLoading(true);
    if (orderId) {
      try {
        const { data } = await Order.getOrderById(orderId, currentLanguage);
        if (data.shippingDate) {
          let date = data.shippingDate.split("T");
          const timeStart =
            data.shippingHourFrom < 10
              ? `0${data.shippingHourFrom}`
              : data.shippingHourFrom;
          const timeEnd =
            data.shippingHourTo < 10 ? `0${data.shippingHourTo}` : data.shippingHourTo;
          data.shippingDate = `${date[0]}T${timeStart}:00:00`;
          data.shippingDateEnd = `${date[0]}T${timeEnd}:00:00`;
        }
        if (data.unloadingDate) {
          let date = data.unloadingDate.split("T");
          const timeStart =
            data.unloadingHourFrom < 10
              ? `0${data.unloadingHourFrom}`
              : data.unloadingHourFrom;
          const timeEnd =
            data.unloadingHourTo < 10 ? `0${data.unloadingHourTo}` : data.unloadingHourTo;
          data.unloadingDate = `${date[0]}T${timeStart}:00:00`;
          data.unloadingDateEnd = `${date[0]}T${timeEnd}:00:00`;
        }
        setOrder(data);
        console.log("[DATA]", data);
      } catch (e) {
        console.log(e);
        toast.error(t('common.genericError'));
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    setIsLoadingMap(true);
    setRouteData(null);

    if (getOrder) {
      const addressList = getOrder.addressList || [];
      const addressListLength = addressList.length || 0;

      if (addressListLength === 2) {
        const loadingAddress = addressList.find(addr => addr.type === 'Loading');
        const unloadingAddress = addressList.find(addr => addr.type === 'Unloading');

        const hasUserAddressIds =
          loadingAddress?.latLng && unloadingAddress?.latLng;

        const routeMethod = hasUserAddressIds
          ? 'getRouteByAddressId'
          : 'getRoute';

        const args = hasUserAddressIds
          ? [loadingAddress.userAddressId, unloadingAddress.userAddressId]
          : [getOrder.cityIdFrom, getOrder.cityIdTo];

        setIsLoadingMap(true);

        MapsData[routeMethod](...args)
          .then((response) => {
            try {
              if (!response?.data?.jsonData) throw new Error('Нет jsonData');
              let parsedData = JSON.parse(response.data.jsonData);

              if (response.data.fromCityId !== getOrder.cityIdFrom) {
                parsedData = parsedData.reverse();
              }

              setRouteStartCity(response.data.fromCityId);
              setRouteData(parsedData);
            } catch (error) {
              console.error('Ошибка при парсинге JSON:', error);
              setRouteData(null);
            } finally {
              setIsLoadingMap(false);
            }
          })
          .catch((error) => {
            console.error(error);
            setIsLoadingMap(false);
            toast.error(t('orderInfo.genericError'));
          });
      } else if (addressListLength > 2) {
        setRouteData(null);
        setIsLoadingMap(false);
      }

      Order.getCargo(getOrder.cargoId)
        .then((response) => {
          if (response.status == 200) {
            setCargoDetails(response.data);
          } else {
            setCargoDetails({});
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error(t('common.genericError'));
        });

      Order.getRecipient(getOrder.recipientId)
        .then((response) => {
          if (response.status == 200) {
            setRecipient(response.data);
          } else {
            setRecipient({});
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error(t('common.genericError'));
        });

      User.getHistory(orderId)
        .then((res) => res.data)
        .then((data) => {
          setBookingDate(data[3]?.createdAt);
          setStatusHistory(data);
        })
        .catch((error) => {
          console.log(error);
          toast.error(t('common.genericError'));
        });

      Order.getCityById(getOrder.cityIdFrom)
        .then((response) => {
          if (response.status == 200) {
            setCityFrom(response.data);
          } else {
            setCityFrom(null);
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error(t('common.genericError'));
        });

      Order.getCityById(getOrder.cityIdTo)
        .then((response) => {
          if (response.status == 200) {
            setCityTo(response.data);
          } else {
            setCityTo(null);
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error(t('common.genericError'));
        });

      User.getCoordinate(getOrder.number)
        .then((response) => {
          if (response.status == 200) {
            const post = [];
            if (response.data && response.data.length) {
              response.data.map((m) => {
                post.push({
                  lat: m.latitude,
                  lng: m.longitude,
                  date: m.createdAtStr,
                  type: m.type,
                });
              });
            }
            setCoordinate(post);
          }
        })
        .catch((error) => {
          console.log(error);
        });

      if (getOrder && getOrder.driverId) {
        File.getDocList(getOrder.driverId)
          .then((response) => {
            const filteredData = response.data.filter((doc) => doc.type !== 8);
            const hasTypes = [4, 5, 7].some((type) =>
              filteredData.some((doc) => doc.type === type),
            );

            setListDocDriver(filteredData);

            if (!hasTypes && getOrder.vehicleId) {
              File.getDocListVehicle(getOrder.vehicleId)
                .then((vehicleResponse) => {
                  const combinedData = [...filteredData, ...vehicleResponse.data];
                  setListDocDriver(combinedData);
                })
                .catch((error) => {
                  console.log("Ошибка при получении документов ТС:", error);
                });
            }
          })
          .catch((error) => {
            console.log("Ошибка при получении документов водителя:", error);
          });
      } else if (getOrder && getOrder.vehicleId) {
        File.getDocListVehicle(getOrder.vehicleId)
          .then((vehicleResponse) => {
            setListDocDriver(vehicleResponse.data);
          })
          .catch((error) => {
            console.log("Ошибка при получении документов ТС:", error);
          });
      } else {
        console.log("Невозможно получить документы: ID водителя и ТС не определены");
        setListDocDriver([]);
      }

      File.getOrderDocsDriverPhotos(getOrder.id)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            setDriverPhotos(response.data);
          }
        })
        .catch((error) => {
          console.log("error order docs", error);
        });

      if (user.type === "Client") {
        Order.getListSuggestedPrice(getOrder.id)
          .then((response) => {
            setListSuggestedPrice(response.data);
          })
          .catch((error) => {
            console.log(error);
          });
      }

      if (getOrder.companyId !== company.id) {
        Order.createOrderView(getOrder.id)
          .then(() => {})
          .catch((error) => {
            console.log(error);
          });
      }
    }
  }, [getOrder]);

  useEffect(() => {
    fetchOrderData();
  }, [orderId]);

  return (
    <div className={cn(style.wrapper_mobile)}>
      <OrdersInfoHeader
        item={getOrder}
        onForceUpdate={onForceUpdate}
      />
      {isLoading ? <Loading borderRadius="16px" /> : null}
      
      {user.type === "Expeditor" && getOrder && getOrder.status !== "awaitingoffer" && getOrder.companyId !== company.id && getOrder.expeditorId !== company.id ? (
        <OrderAccessRestricted isModal={false} />
      ) : (
      <div className={style.orders_content}>
        <OrdersInfoBasic item={getOrder} onOpen={() => setIsOpenModalHistory(true)} />
        {isOpenModalHistory ? (
          <OrderHistoryMobile
            item={getOrder}
            isOpen={isOpenModalHistory}
            statusHistory={statusHistory}
            onClose={() => setIsOpenModalHistory(false)}
            senderName={companyName}
            recipientName={recipient?.name}
            cargoDetails={cargoDetails}
            cityFrom={cityFrom}
            cityTo={cityTo}
            routeData={routeData}
            isLoadingMap={isLoadingMap}
            routeStartCity={routeStartCity}
            coordinateTruck={coordinate}
            bookingDate={bookingDate}
            driverPhotos={driverPhotos}
            listDocDriver={listDocDriver}
          />
        ) : null}

        {getOrder && getOrder.addressList.length < 1 ? (
          <OrdersInfoDirections
            item={getOrder}
            senderName={companyName}
            recipientName={recipient?.name}
          />
        ) : (
          <OrdersInfoAddressList
            order={getOrder}
            addressList={getOrder?.addressList}
          />
        )}

        {listSuggestedPrice.length > 0 && (
          <ListSuggestedPrices
            items={listSuggestedPrice || []}
            fetchOrderData={fetchOrderData}
            isExpeditor={getOrder.expeditorId}
            ordersStatus={getOrder.status}
            onUpdateData={() => onForceUpdate()}
            cargoDetails={cargoDetails}
          />
        )}

        {isSearchPage && getOrder && getOrder.status === "published" && (
          <OrderBidOrBook
            user={user}
            orderId={getOrder.id}
            onUpdateData={() => onForceUpdate()}
            fetchOrderData={fetchOrderData}
            item={getOrder}
            cargoDetails={cargoDetails}
          />
        )}

        {getOrder && (getOrder.drivers?.length > 0 || getOrder.driverId) && (
          <OrdersDriverInfo
            item={getOrder}
            drivers={getOrder.drivers || []}
            driverId={getOrder.driverId}
            recipientName={recipient?.name}
            senderName={companyName}
            bookingDate={bookingDate}
            listDocDriver={listDocDriver}
          />
        )}
        <OrdersInfoCargo item={cargoDetails} order={getOrder} />
        <span className={style.orders_author}>
          <InfoIcon /> {getOrder?.author} {getOrder?.createdAtStr}
        </span>
      </div>
      )}
    </div>
  );
};

export default OrderInfoBookingCardMobile;
